import uploadFileService from "../Services/uploadFileService";
import { showToast } from "./toast";
import { SET_FAILED_MESSAGE, SET_SUCCESS_MESSAGE } from "./type";
import { startLoaderAction, stopLoaderAction } from "./updateReducerValue";

export const uploadFileAction = (payload) => (dispatch) => {
  dispatch(startLoaderAction());
  return uploadFileService.uploadFile(payload).then((resp) => {
    if (resp.status) {
      dispatch(showToast(resp?.data, "success"));
      dispatch(stopLoaderAction());
    } else {
      dispatch(showToast(resp?.data, "error"));
      dispatch(stopLoaderAction());
    }
    return resp;
  });
};

export const uploadFileByFormData = (payload) => (dispatch) => {
  return uploadFileService.uploadFileSingle(payload).then((resp) => {
    return resp;
  });
};

